import Vue from 'vue';
import Router from 'vue-router';
import Home from '../views/Home.vue';
import Services from '../views/Services.vue';
import About from '../views/About.vue';
import Cases from '../views/Cases.vue';
import Contact from '../views/Contact.vue';
import WhyUs from '../views/WhyUs.vue';
import News from '../views/News.vue';

Vue.use(Router);

export default new Router({
  mode: 'hash',
  scrollBehavior: function () {
    return { x: 0, y: 0 };
  },
  routes: [
    { path: '/', name: 'home', component: Home },
    { path: '/company', name: 'company', component: About },
    { path: '/services', name: 'services', component: Services },
    { path: '/why-us', name: 'why-us', component: WhyUs },
    { path: '/portfolio', name: 'portfolio', component: Cases },
    { path: '/news', name: 'news', component: News },
    { path: '/contact', name: 'contact', component: Contact }
  ]
});
